export default "__VITE_ASSET__R6lra9_v__"